// extracted by mini-css-extract-plugin
module.exports = {"autocompleteSuggestions":"AutoComplete_autocompleteSuggestions__38RUj","autocompleteBox":"AutoComplete_autocompleteBox__2bdnx"};